import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_CLASSWORK_PERFORMANCE,
  GET_ALL_CLASSWORK_PERFORMANCE,
  GET_STUDENT_CLASSWORK_PERFORMANCE,
  GET_CLASSWORK_PERFORMANCE,
  GET_CLASSWORK_PERFORMANCE_BATCH,
  UPDATE_CLASSWORK_PERFORMANCE,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

//GET ALL CLASSWORK PERFORMANCE RESULT
export const getAllClassworkPerformance =
  (batchId, year, month, gradeId, shiftId) => async (dispatch) => {
    const data = {
      batchId,
      year,
      month,
      gradeId,
      shiftId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/classwork-performance/all`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_ALL_CLASSWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET CLASSWORK PERFORMANCE RESULT FOR STUDENT INTERVAL
export const getClassworkPerformanceResult =
  (startMonth, startYear, endMonth, endYear, studentId, year, gradeId, shiftId, batchId) =>
  async (dispatch) => {
    const data = {
      startMonth,
      startYear,
      endMonth,
      endYear,
      year,
      gradeId,
      shiftId,
      batchId,
      studentId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/classwork-performance/between`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_CLASSWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET STUDENT LIST FOR CLASSWORK PERFORMANCE (students without entries)
export const getClassworkPerformanceStudentForBatch =
  (year, month, batchId) => async (dispatch) => {
    const data = {
      year,
      month,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/classwork-performance/batch`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_STUDENT_CLASSWORK_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

//GET BATCH STUDENTS WITH CLASSWORK PERFORMANCE
export const getBatchClassworkPerformanceResult =
  (year, month, batchId) => async (dispatch) => {
    const data = {
      year,
      month,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/classwork-performance/batch-res`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_CLASSWORK_PERFORMANCE_BATCH,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

// CREATE CLASSWORK PERFORMANCE
export const createClassworkPerformance = (month, year, marks) => async (dispatch) => {
  let data = {
    month: parseInt(month),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${BASE_URL}/api/classwork-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: CREATE_CLASSWORK_PERFORMANCE,
    });
    toast.success("Classwork performance added successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// EDIT CLASSWORK PERFORMANCE
export const editClassworkPerformance = (month, year, marks) => async (dispatch) => {
  let data = {
    month: parseInt(month),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.patch(
      `${BASE_URL}/api/classwork-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: UPDATE_CLASSWORK_PERFORMANCE,
    });
    toast.success("Classwork performance edited successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};
